import React from 'react';
import { objectsForEach } from '../../common/objectToArray';
import { uploadLeadDocument } from '../../services/manage-leads';
import AdditionalInfoCTA from '../../../src/Views/Portfolio/ViewPortfolio/AdditionalInfo/AdditionalInfoCTA';
import AdditionalInfoTRNCH from '../../../src/Views/Portfolio/ViewPortfolio/AdditionalInfo/AdditionalInfoTRNCH';
import splitUnderscoreToCaptialise from '../../common/splitUnderscoreToCaptialise';
import Select from '../../components/Common/Input/Select';
import BranchCode from './BranchCode';
const Input = ({
	rule,
	label,
	id,
	errors,
	type,
	parentIndex,
	parentId,
	setBody,
	params = {},
	body,
	edit,
	leadId,
	selectedLender,
	setErrors
}) => {
	const [addInfoModalState, setAddInfoModalState] = React.useState(false);
	const handleAdditionalInfoModal = () => {
		setAddInfoModalState(!addInfoModalState)
	}
	const getStyles = id => {
		switch (id) {
			case 'pan_no':
			case 'comp_pan':
			case 'gst_no':
			case 'org_pan':
			case 'pan_number':
			case 'UdyamAadharNo':
				return { textTransform: 'uppercase' };
		}
	};
	const onChange = async e => {
		let newErr = errors;
		let value;
		let inputValue = e?.target?.value || e?.value || '';
		if (rule.input_type === 'file') {
			const response = await uploadLeadDocument(e.target.files[0]);
			if (response?.status?.code) {
				inputValue = response.data.resource.file_id;
			}
		}
		if (type === 'multiple') {
			value = body[parentId];
			value[parentIndex] = {
				...value[parentIndex],
				...resetFlags(params),
				[id]: inputValue
			};
			delete newErr?.[parentId]?.[parentIndex]?.[id]
		} else {
			value = {
				...body[parentId],
				...resetFlags(params),
				[id]: inputValue
			};
			delete newErr?.[parentId]?.[id]
		}
		setErrors(newErr)
		setBody(values => {
			return {
				...values,
				...body,
				[parentId]: value
			};
		});
	};
	const resetFlags = (params) => {
		let flags = (params || []).filter(param => param.id == id);
		let flag_values = {};
		(flags?.[0]?.reset_flags || []).map(val => {
			flag_values[val] = '';
		});
		return flag_values;
	}

	const getSelectedValueData = (dataArr, selectedValue) => {
		return dataArr.filter(obj => obj.value === selectedValue);
	}

	const getDate = (future_date, year=20) => {
		if(future_date){
			return (new Date(new Date().setFullYear(new Date().getFullYear() + year))).toISOString().split('T')[0];
		}else{
			return (new Date()).toISOString().split('T')[0];
		}
	}

	const getSelectOptions = (opt) => {
		return objectsForEach(opt, 'STRING_VAL').map(({ value, id }) => ({ label: id, value: value }))
	};

	if (rule.input_type === 'branch_code') {
		return <BranchCode />;
	}
	if (rule.input_type === 'dropdown') {
		return (
			<>
				{rule.searchable ?
					<>
						<span style={{ 'font-weight': 700, position: 'absolute', top: '28px', right: '47px', zIndex: '1',color: '#9e9e9e', cursor: 'pointer' }} type="button" onClick={rule.disabled ? () => { } : onChange}>X</span>
						<Select
							label=''
							options={getSelectOptions(rule.options)}
							onChange={rule.disabled ? () => { } : onChange}
							value={type === 'multiple'
								? getSelectedValueData(getSelectOptions(rule.options), body?.[parentId]?.[parentIndex]?.[id])
								: getSelectedValueData(getSelectOptions(rule.options), body?.[parentId]?.[id])}
							isMulti={false}
						/>
					</>
					:
					<select
						disabled={
							rule.disabled || (!edit && leadId) || (edit && id === 'assigned_to')
						}
						value={
							type === 'multiple'
								? body?.[parentId]?.[parentIndex]?.[id]
								: body?.[parentId]?.[id]
						}
						onChange={rule.disabled ? () => { } : onChange}
						className='form-control'
					>
						<option value={''}>{'Please Select'}</option>
						{objectsForEach(rule.options, 'STRING_VAL').map(({ value, id }) => (
							<option value={value}>{splitUnderscoreToCaptialise(id)}</option>
						))}
					</select>
				}

				{errors && (
					<p className='mb-3by4 text-danger'>
						{type === 'multiple'
							? errors?.[parentId]?.[parentIndex]?.[id]
							: errors?.[parentId]?.[id]}
					</p>
				)}
			</>
		);
	}
	if (rule.input_type === 'cta') {
		return (
			<>
				<AdditionalInfoCTA
					modalState={addInfoModalState}
					toggleModal={handleAdditionalInfoModal}
					onChange={onChange}
					params={params}
					keyName={id}
					selectedLender={selectedLender}
					leadId={leadId}
					body={body}
				/>
				<span
					style={{ padding: "10px", width: "fit-content" }}
					className='btn btn-custom mr-1'
					onClick={handleAdditionalInfoModal}
					value={
						rule.input_type !== 'file' && type === 'multiple'
							? (body?.[parentId]?.[parentIndex]?.[id] || '')
							: (body?.[parentId]?.[id] || '')
					}
				>
					{label}
				</span>
				{errors && (
					<p className='mb-3by4 text-danger'>
						{type === 'multiple'
							? errors?.[parentId]?.[parentIndex]?.[id]
							: errors?.[parentId]?.[id]}
					</p>
				)}
			</>
		);
	}
	if (rule.input_type === 'trnch') {
		return (
			<>
				<AdditionalInfoTRNCH
					modalState={addInfoModalState}
					toggleModal={handleAdditionalInfoModal}
					onChange={onChange}
					params={params}
					keyName={id}
					selectedLender={selectedLender}
					leadId={leadId}
					body={body}
				/>
				<span
					style={{ padding: "10px", width: "fit-content" }}
					className='btn btn-custom mr-1'
					onClick={handleAdditionalInfoModal}
					value={
						rule.input_type !== 'file' && type === 'multiple'
							? (body?.[parentId]?.[parentIndex]?.[id] || '')
							: (body?.[parentId]?.[id] || '')
					}
				>
					{label}
				</span>
				{errors && (
					<p className='mb-3by4 text-danger'>
						{type === 'multiple'
							? errors?.[parentId]?.[parentIndex]?.[id]
							: errors?.[parentId]?.[id]}
					</p>
				)}
			</>
		);
	}
	return (
		<>
			<input
				disabled={rule.disabled || (!edit && leadId)}
				onChange={rule.disabled ? () => { } : onChange}
				onKeyDown={event => {
					var invalidChars = ['-', '+', 'e'];
					if (id === 'cibil_score' && event.key == '-') {
						return;
					} else if (
						rule.input_type === 'number' &&
						invalidChars.includes(event.key)
					) {
						event.preventDefault();
						return;
					}
				}}
				type={rule.input_type}
				max={rule.input_type == 'date' ? getDate(rule?.future_date) : ''}
				className='form-control'
				value={
					rule.input_type !== 'file' && type === 'multiple'
						? (body?.[parentId]?.[parentIndex]?.[id] || '')
						: (body?.[parentId]?.[id] || '')
				}
				style={getStyles(id)}
			/>
			{rule.input_type === 'file' &&
				(type === 'multiple' ? (
					<a
						className='link'
						href={body?.[parentId]?.[parentIndex]?.[id + '_url']}
						// target='_blank'
					>
						{body?.[parentId]?.[parentIndex]?.[id + '_filename']}
					</a>
				) : (
					<a
						className='link'
						href={body?.[parentId]?.[id + '_url']}
						// target='_blank'
					>
						{' '}
						{body?.[parentId]?.[id + '_filename']}
					</a>
				))}
			{errors && (
				<p className='mb-3by4 text-danger'>
					{type === 'multiple'
						? errors?.[parentId]?.[parentIndex]?.[id]
						: errors?.[parentId]?.[id]}
				</p>
			)}
		</>
	);
};

export default Input;
